import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IconButton, Icon, Panel, Row, Message } from 'rsuite'
//import { useParams } from 'react-router-dom'

import { useForm, Controller } from 'react-hook-form'
import scrollToComponent from 'react-scroll-to-component'
// import ProjectTypeGroup from './ProjectTypeGroup'
import SubProjectTypeGroup from './SubProjectTypeGroup'
import ProjectTypeGroupView from './ProjectTypeGroupView'
import {
  saveSubProjectProjectType,
  updateSubProjectProjectType,
} from '../../../redux/actions/projectType'
import { doneLoading, startLoading } from '../../../utils/loading'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../../redux/actions/sidebar'
import ButtonPanel from '../../ButtonPanel'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function SubProjectTypeGroupWidget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [section, setSection] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        response = await updateSubProjectProjectType(projectId, request, request.id)
      } else {
        response = await saveSubProjectProjectType(projectId, request)
      }

      setFormSchema(response)
      await dispatch(getSchemaSubProjectSidebar(projectId))
      onChangeIsEdit(false)
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      userId: 1,
      projectFeature: data.projectFeature,
      projectType: data.projectType,
      subProject: data.subProject,
      subProjectCode: data.projectCode,
      offerFunded: data.offerFunded,
      startDate: data.startDate,
      endDate: data.endDate,
      monthCount: data.monthCount,
      projectReportDay: data.projectReportDay || 0,
    }

    handleCallService(request)
  }

  return (
    <div>
      <Panel
        header={formSchema.header}
        defaultExpanded
        collapsible
        bordered
        shaded
        ref={(section) => {
          setSection(section)
        }}
      >
        <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

        {isEdit && showCommandButton ? (
          <SubProjectTypeGroup
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            getValues={getValues}
          />
        ) : (
          <ProjectTypeGroupView schema={formSchema} isSubProject={true} />
        )}

        {showCommandButton && (
          <>
            <hr />
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={formSchema.buttonText || 'ลักษณะข้อเสนอโครงการ'}
              onSave={handleSubmit(onSubmit)}
              onCancel={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
              }}
              onEdit={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
          </>
        )}
      </Panel>
    </div>
  )
}
